import AxiosInterceptor from 'api/interceptor';

const language = new AxiosInterceptor();

export default {
  getSupported() {
    return language.get('/site/languages/list');
  },
  get(inputs = {page: 1, limit: 10}) {
    inputs.page = inputs.page ? inputs.page : 1;
    inputs.limit = inputs.limit ? inputs.limit : 10;
    return language.get('/site/languages');
  },
  active(id, inputs) {
    return language.put('/site/languages/' + id, {
      'active': inputs.active
    });
  }
};